query LanguageEdit($id: ID!) {
  language(id: $id) {
    id
    title
    native
    code
    translation
  }
}
